var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({on:{"click":_vm.onClick}},on),[_vm._v("delete")])]}}])},[_c('span',[_vm._v("設定の削除")])])
}
var staticRenderFns = []

export { render, staticRenderFns }